"use strict";

exports.__esModule = true;
exports.AdvancedTimelineTimeContextSelector = AdvancedTimelineTimeContextSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _Selector = require("../../Core/Selector");
var _LayoutSettingsContext = require("../../ConfigurableLayout/LayoutSettingsContext");
var _SelectorOption = require("./SelectorOption");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedTimelineTimeContextSelector(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var layoutSettings = _react["default"].useContext(_LayoutSettingsContext.LayoutSettingsContext);
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element;
  if (!layoutSettings.selection.allowReportingPeriod) {
    return null;
  }
  var _onSelect = function onSelect(dataRange) {
    elementEditor.setProps(path, Object.assign({}, element.props, {
      dataRange: dataRange,
      showBrush: false,
      brushEnableDragging: false,
      brushEnableResize: false,
      brushEnableSnapToSelection: false,
      brushEnableSnapToTimeline: false
    }));
  };
  var dataRangeOptions = [{
    id: "",
    label: translate("AdvancedDataTableFields.dataRange.reportingPeriod.label", "Reporting Period")
  }, {
    id: "SELECTION",
    label: translate("AdvancedDataTableFields.dataRange.selection.label", "Selection")
  }];
  var selectedDataRange = dataRangeOptions.find(function (dataRange) {
    return dataRange.id === element.props.dataRange;
  }) || dataRangeOptions[0];
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("AdvancedTimelineTimeContextSelector.dataRange.label", "Data Range"),
    helperText: translate("AdvancedTimelineTimeContextSelector.dataRange.helperText", "The data range to show in this stripe chart.")
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    items: dataRangeOptions,
    getKey: function getKey(dataRange) {
      return dataRange.id;
    },
    selected: [selectedDataRange],
    onSelect: function onSelect(selectedDataRange) {
      return selectedDataRange.length ? _onSelect(selectedDataRange[0].id) : null;
    },
    renderItemText: function renderItemText(dataRange) {
      return /*#__PURE__*/_react["default"].createElement(_SelectorOption.SelectorOption, {
        value: dataRange.label,
        parentComponent: "AdvancedTimelineTimeContextSelector"
      });
    },
    placeholder: translate("AdvancedTimelineTimeContextSelector.dataRangeSelector.label", "Select Data Range"),
    width: 275
  }));
}